import { THEME_COLORS } from '../constants'

export const hexToRgba = (hex = '', alpha = 1) => {
  const normalized = String(hex).replace('#', '')

  if (normalized.length !== 3 && normalized.length !== 6) {
    return hex
  }

  const full = normalized.length === 3
    ? normalized.split('').map((c) => c + c).join('')
    : normalized

  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const colorThemeSelector = (colorTheme = '') => {
  const selectedTheme = colorTheme ? colorTheme.toUpperCase() : '#CFB58F'
  
  for (const theme in THEME_COLORS) {
    if(THEME_COLORS[theme].MAIN === selectedTheme) {
      return THEME_COLORS[theme]
    }
  }
  
  return THEME_COLORS.GOLD_THEME
}
